import { OnInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ServicioNotasEnfermeriaService, ParametrosNotasEnfermeriaEntity, EntidadEmpresarial
} from 'src/app/services/servicio-notas-enfermeria.service';

@Component({
  selector: 'app-reporte-notas-enfermeria',
  templateUrl: './reporte-notas-enfermeria.component.html',
  styleUrls: ['./reporte-notas-enfermeria.component.css']
})
export class ReporteNotasEnfermeriaComponent implements OnInit {

  loading: boolean;
  filtrosSeleccionados: any;
  fechaImpresion: Date;
  datosBaseResolucionEntity: any;

  public parametrosNotasEnfermeria: ParametrosNotasEnfermeriaEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: 0,
    uncoEntidad: ''
  };
  public entidadEmpresarial: EntidadEmpresarial = {
    unco: 0,
    nombreEntidad: '',
    nit: '',
    digitoVerificacion: '' ,
    direccion: '',
    telefono: '',
  };

  constructor(private activatedRoute: ActivatedRoute, private servicioNotasEnfermeria: ServicioNotasEnfermeriaService) {
    this.activatedRoute.params.subscribe(params => {
      this.parametrosNotasEnfermeria.codigoBaseDatos = params['codigoBaseDatos'];
      this.parametrosNotasEnfermeria.uncoSede = params['uncoSede'];
      this.parametrosNotasEnfermeria.uncoEntidad = params['uncoEntidad'];
      this.parametrosNotasEnfermeria.uncoLogin = params['user'];

    });
  }
  ngOnInit() {
  }

  public updateEntidad(entidad: EntidadEmpresarial) {
    this.entidadEmpresarial = entidad;
  }

}
